import React, {Component} from 'react';
import historyIcon from './history.png';
import NormalButton from "../normalButton";
import { Scrollbars } from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";
import {Empty, message} from "antd";
import moment from 'moment';
import onClickOutside from "react-onclickoutside";

class History extends BaseComponent {

    state = {
        list : [],
        listVisible: false
    };

    dataType = "website";
    constructor(props) {
        super(props);
        if(this.props.editor && this.props.editor.dataType){
            this.dataType = this.props.editor.dataType
        }
    }

    editorId;
    componentDidMount() {
        let editorId = this.props.dynamicParams.editorId;
        this.editorId = editorId;
        if(editorId){
            this.getHistoryData(editorId);
        }else if(this.props.dynamicParams.oldId){
            this.getStoryHistory(this.props.dynamicParams.oldId);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let editorId = nextProps.dynamicParams.editorId;
        if(editorId){
            if(editorId !== this.editorId){
                this.editorId = editorId;
                this.getHistoryData(editorId);
            }
        }else if(nextProps.dynamicParams.oldId != this.props.dynamicParams.oldId){
            this.getStoryHistory(nextProps.dynamicParams.oldId);
        }
    }

    getHistoryData(editorId){
        if(editorId){
            let url = "/cm-sites-pms/website/news/getWebNewsHistory";
            let body = {webNewsId:editorId};
            console.log("this.dataType:   ", this.dataType, this.dataType === "story");
            if(this.dataType === "story"){
                url = "/cm-sites-pms/story/getStoryHistory";
                body = {storyId:editorId};
            }
            if(this.dataType === "rmapp"){
                url = "/cm-sites-mmp/mf/getMediaFusionHistory";
                body = {mediaFusionId: editorId};
            }
            this.request({
                url, body,
                callBack: (list)=>{
                    if(list && list.length) {
                        this.setState({list})
                    } else {
                        if(
                            this.urlParams &&
                            this.urlParams.storyId &&
                            this.urlParams.storyId != editorId
                        ) {
                            this.getHistoryData(this.urlParams.storyId)
                        }
                    }
                }
            })
        }
    }

    getStoryHistory(storyId){
        this.dataType = "story";
        let url = "/cm-sites-pms/story/getStoryHistory";
        let body = {storyId:storyId};
        this.request({
            url, body,
            callBack: (list)=>{
                if(list && list.length) {
                    this.setState({list})
                }
            }
        })
    }

    render() {
        return (
            <span style={{position:"relative"}}>
                <NormalButton onClick={()=>{
                    this.setState({
                        listVisible:!this.state.listVisible
                    })
                }} style={this.props.style} icon={historyIcon} text={"历史记录"}/>
                <HistoryList
                    diffOnClick={() => {
                        let id = this.props.dynamicParams.editorId;
                        if (!id) {
                            id = this.props.dynamicParams.oldId;
                        }
                        window.open(`#/view/htmldiff/htmldiff/history/${this.dataType}/${id}`)
                    }}
                    itemComponentClick={(editor, item) => {
                        this.getStoryData(item,(data)=>{
                            editor.setContent(data.content);
                            editor.setCurrentInformation(data);
                        });
                    }}
                    itemComponent={HistoryItem} title={"历史记录"} editor={this.props.editor}
                    visible={this.state.listVisible} data={this.state.list}
                />
            </span>
        );
    }

    // 获取稿件详情
    getStoryData = (data,call) => {
        // // 历史记录数据专门存在历史记录接口中，这里的data就是当前选择的某一条历史记录数据
        call(data?.history || {})
        // if(data && data.id && data.type) {
        //     let url = "";
        //     let body = null;
        //     switch (data.type) {
        //         case "WbNews":
        //             url = "/cm-sites-pms/website/news/getById";
        //             body = {webNewsId:data.id};
        //             break;
        //         case "Story":
        //             url = "/cm-sites-pms/story/show";
        //             body = {storyId:data.id};
        //             break;
        //     }
        //     if(url&&body){
        //         this.request({
        //             url,body,
        //             callBack: (res) => {
        //                 if(res) {
        //                     call&&call(res)
        //                 } else {
        //                     call&&call(data)
        //                 }
        //             },
        //             errorCallBack: function (res) {
        //                 call&&call(data)
        //             }
        //         })
        //     }
        // } else {
        //     call&&call(data)
        // }
    };

    handleClickOutside = (evt) => {
        this.setState({
            listVisible: false
        })
    };
}

export class HistoryList extends BaseComponent{

    render() {
        let ItemComponent = this.props.itemComponent;
        let itemComponentStyle = this.props.itemComponentStyle || {};
        let dataEmpty = (!this.props.data || (this.props.data.length === 0));
        return <div style={{display:this.props.visible? "block":"none",width:300,position:"absolute",borderRadius:4,top:41,left:-200,background:"#fff",zIndex:9999,boxShadow:"0px 0px 5px #d9d3d3"}}>
            <table cellSpacing={0} cellPadding={0} border={0} width={"100%"} height={"100%"}><tbody>
                <tr height={50}>
                    <td style={{padding:"5px 15px", cursor:"default"}}><b>{this.props.title}</b></td>
                    <td style={{padding: "5px 25px", cursor:this.props.diffOnClick? "pointer":''}} align={"right"}>
                        {!dataEmpty && this.props.diffOnClick && <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}} onClick={() => {
                            this.props.diffOnClick && this.props.diffOnClick();
                        }}>版本对比</span>}
                    </td>
                </tr>
                <tr>
                    <td colSpan={2} valign={"top"} style={{borderTop:"1px solid #ccc",padding:"0px 0px 10px 10px"}}>
                        {
                            dataEmpty ? <Empty style={{marginTop:10}}/> :
                            <Scrollbars
                                autoHeight
                                autoHeightMax={this.props.isContentDetail === 'contentSecurityCenter' ? '680px' : '400px'}
                                autoHide={true}
                            >
                                <div
                                    style={{padding: this.props.isContentDetail === 'contentSecurityCenter' ? '0 10px 0 0' : '0 22px 0 0'}}>
                                    {
                                        this.props.data && this.props.data.map((item,index)=>{
                                            return <ItemComponent
                                                key={index}
                                                onClick={()=>{
                                                    this.props.data.map(item=>{
                                                        item.historyItemClassName = "historyItem";
                                                    });
                                                    item.historyItemClassName = "historyItemCheck";
                                                    this.setState({});
                                                    this.props.itemComponentClick && this.props.itemComponentClick(this.props.editor, item, index);
                                                }}
                                                className={item.historyItemClassName}
                                                item={item}
                                                prevItem={index > 0? this.props.data[index - 1]: null}
                                                nextItem={(this.props.data.length - 1 > index) ? this.props.data[index + 1]: null}
                                                color={this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}
                                                style={{marginTop:10,height:80, cursor:"pointer", ...itemComponentStyle}}
                                            />
                                        })
                                    }
                                </div>
                            </Scrollbars>
                        }
                        <style>{`
                            .historyItemCheck{
                                background: #ccd9eb !important
                            }
                            .historyItem{
                                background: #ebf1f9
                            }
                        `}</style>
                    </td>
                </tr>
            </tbody></table>
        </div>
    }

}

class HistoryItem extends Component{
    static defaultProps = {
        style:{},
        className:"historyItem",
        onClick:()=>{}
    };

    render (){
        let {item} = this.props;
        return <div onClick={()=>{
            this.props.onClick()
        }} className={this.props.className} style={{borderLeft:'3px solid #24B481',borderRadius:3,padding:10,borderColor:this.props.color,...this.props.style}}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"100%"}>
                <tbody>
                <tr>
                    <td valign={"middle"}>
                        <div className={"plan-pointer"} style={{width:"260px",paddingLeft:5,overflow:"hidden",textOverflow: "ellipsis",whiteSpace: "nowrap"}}>{item.operator?item.operator:"错误数据"}</div>
                    </td>
                </tr>
                <tr>
                    <td valign={"middle"}>
                        <div className={"plan-pointer"} style={{marginRight: 20,paddingLeft:5, color:"#ada4a4"}}>{moment(item.createTime).format("yyyy-MM-DD HH:mm:ss")}</div>
                    </td>
                </tr>
                </tbody>
            </table>
            <style>{`
                .historyItem:hover{
                    background: #ccd9eb !important
                }
            `}</style>
        </div>
    }
}
export default onClickOutside(History);